import { bootstrap } from "@usable/office-shell";
import { getSupportedWordToolSchemas, handleWordToolCall } from "./lib/word-tools";
import { wordContextProvider } from "./lib/word-context";

// The whole Word add-in: host-specific tools + config; the shared shell does the rest.
// Logo + ribbon icons come from the shared @usable/office-assets brand set.
//
// Capability gating (Word Power Tools PRD §5.2): the tool schemas must be filtered
// by what the running host actually supports, and `Office.context.requirements`
// is only reliable AFTER Office is ready. `wordToolSchemas` is computed at module
// import — before onReady — so we resolve the gated schemas here, inside onReady,
// and pass them to bootstrap. bootstrap's own internal `Office.onReady` then
// resolves immediately (nesting is safe).
Office.onReady(() => {
  const toolSchemas = getSupportedWordToolSchemas();
  logWordApiSupportMatrix(toolSchemas.length);

  bootstrap({
    appName: "Word Assistant",
    documentNoun: "document",
    embedToken:
      process.env.EMBED_TOKEN ??
      "uc_639351250a26aca5b6076572cb3b1b182ca7b4861813a4bc1d8df2075543def1",
    dbName: "usable-word-chat-history",
    toolSchemas,
    // Thread the embed's requestId so the shared execution layer dedups
    // double-mount re-deliveries exactly (not by content — which collapses
    // legitimate parallel same-args calls).
    onToolCall: (tool, args, caps) => handleWordToolCall(tool, args, caps.requestId),
    contextProvider: wordContextProvider,
  });
});

/** Dev aid: log which WordApi requirement sets this host supports + advertised tool count. */
function logWordApiSupportMatrix(advertisedToolCount: number): void {
  try {
    const sets = ["1.1", "1.2", "1.3", "1.4", "1.5"];
    const matrix = sets.map(
      (s) => `${s}:${Office.context.requirements.isSetSupported("WordApi", s) ? "✓" : "✗"}`
    );
    // eslint-disable-next-line no-console
    console.log(
      `[word-tools] WordApi support — ${matrix.join("  ")} — advertising ${advertisedToolCount} tools`
    );
  } catch {
    // requirements API unavailable (e.g. very old host) — gating already degrades
    // to "supported", so nothing to log.
  }
}
